<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.b2b && localService.languageContent.table">
    <div class="banner center" style="margin-top:10px;max-width: 800px;">
        <div class="row row_header freeze_height">
            <div class="col-8">
                <button class="button_icon button_icon_color" style="float: left;"
                    title="{{localService.languageContent.common.add}}" (click)="onAction(1)">
                    note_add
                </button>
                {{localService.languageContent.b2b.acct_name}}
            </div>
            <div class="col-4">
                {{localService.languageContent.table.created_on}}
                <button class="button_icon button_icon_color" style="float: right;"
                    title="{{localService.languageContent.common.add}}" (click)="onLoad()">
                    refresh
                </button>
            </div>
        </div>
        <div *ngIf="source">
            <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
                <div class="row styled_row freeze_height" *ngFor="let item of source.items">
                    <div class="col-8">
                        <button class="button_icon button_icon_color" style="float: left;top:1px"
                            (click)="onAction(3,item.key)">
                            more_horiz
                        </button>
                        <span class="en">{{item.v2}}</span>
                    </div>
                    <div class="col-4">
                        <span class="en">{{item.v1 | localDate}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-paging *ngIf="source && source.paging" [paging]="source.paging" [IsShowDateRange]="true"
        (onPagingRefreshed)="onLoad()"></app-paging>
</div>
<div>
    <app-more-actions [(isOpenPopup)]="isActionPopupOpen" [items]="moreActionItems" [title]="actionTitle"
        (onClicked)="onMoreActionClicked($event)" />
    <app-b2b-account [(isOpenPopup)]="isB2bAccountPopupOpen" [b2bAccountId]="selectedB2bAccountId"
        (onClose)="onLoad()"></app-b2b-account>
    <app-b2b-owner [(isOpenPopup)]="isB2bOwnerPopupOpen" [b2bAccountId]="selectedB2bAccountId"></app-b2b-owner>
    <span style="display: none;">
        <button class="on_as_country_changed" (click)="onChangeAsCountry()">As Country Changed</button>
    </span>
</div>